import cocktailImg from "../assets/images/cocktail.png";
import shopifyImg from "../assets/images/shopify.png";
import wanderImg from "../assets/images/wander.png";
import fithubImg from "../assets/images/fithub.png";
import fithubBImg from "../assets/images/fithub-B.png";
import heroImg from "../assets/images/hero.png";
import bmkImg from "../assets/images/bmk.png";
import oneImg from "../assets/images/onef.png";

export const SKILLS = [
  {
    title: "Frontend",
    icon: "https://static.thenounproject.com/png/4869316-200.png",
    skills: [
      { skill: "HTML5", percentage: "95%" },
      { skill: "CSS3 (Sass/SCSS)", percentage: "90%" },
      { skill: "JavaScript", percentage: "80%" },
      { skill: "React.js", percentage: "85%" },
      { skill: "Typescript", percentage: "70%" },
      { skill: "Next.js", percentage: "40%" },
    ],
  },
  {
    title: "Backend",
    icon: "https://static.thenounproject.com/png/4505845-200.png",
    skills: [
      { skill: "Ruby", percentage: "85%" },
      { skill: "Node.js", percentage: "70%" },
      { skill: "Express.js", percentage: "50%" },
      { skill: "API", percentage: "80%" },
      { skill: "SQL", percentage: "90%" },
      { skill: "Firebase", percentage: "80%" },
      { skill: "MongoDB", percentage: "90%" },
    ],
  },
  {
    title: "Tools",
    icon: "https://www.svgrepo.com/show/41427/tools.svg",
    skills: [
      { skill: "Git & GitHub", percentage: "85%" },
      { skill: "Visual Studio Code", percentage: "90%" },
      { skill: "Webpack", percentage: "70%" },
      { skill: "Responsive Design", percentage: "85%" },
    ],
  },
  {
    title: "Soft Skills",
    icon: "https://cdn-icons-png.flaticon.com/512/33/33308.png",
    skills: [
      { skill: "Problem-solving", percentage: "85%" },
      { skill: "Collaboration", percentage: "90%" },
      { skill: "Attention to Detail", percentage: "80%" },
    ],
  },
];

export const WORK = [
  {
    title: "Software Engineer Intern",
    company: "Italanta",
    date: "September 2023 - Present",
    responsibilities: [
      "Managed and upheld network infrastructure, overseeing the configuration of devices such as printers, scanners, and ETRs.",
      "Performed installations and upkeep of operating systems, drivers, antivirus software, and critical applications.",
      "Additionally, ensured seamless networking operations by troubleshooting connectivity issues and optimizing network performance.",
    ],
  },
  {
    title: "Information Technology Intern",
    company: "Ministry of Petroleum and Mining Kenya",
    date: "May 2022 - August 2022",
    responsibilities: [
      "Utilized Git for version control, ensuring a seamless and organized workflow within the development team.",
      "Spearheaded the development of three Elewa Group website pages using React and TypeScript, enhancing their responsiveness for optimal viewing across all devices.",
    ],
  },
];

export const EDUCATION = [
  {
    school: "KCA University",
    date: "May 2024 - Present",
    expertise: [
      "Data Structures and Algorithms: Acquiring expertise in efficient data organization and problem-solving techniques.",
      "Mobile App and Game Development: Learning to create engaging mobile applications and games.",
      "Cloud Computing: Mastering the use of cloud platforms for scalable and reliable computing.​",
      "AI Development: Developing knowledge in building intelligent systems and applications.​",
    ],
  },
  {
    school: "Moringa School",
    date: "February 2023 - August 2023",
    expertise: [
      "Frontend Development: Mastered HTML, JavaScript, React, Bootstrap, and CSS for interactive UIs.",
      "Backend Development: Expertise in Ruby, Ruby on Rails, SQLite, and Restful APIs for robust server-side applications.",
      "Authentication & Authorization: Developed secure user authentication systems to safeguard data integrity.​",
      "Soft Skills: Cultivated effective collaboration, time management, and adaptability through team projects.​",
    ],
  },
  {
    school: "Jomo Kenyatta University Of Technology and Agriculture",
    date: "January 2021 - June 2023",
    expertise: [
      "Networking and Security: Acquired knowledge in configuring and securing network devices, troubleshooting, and network maintenance.​",
      "Operating Systems: Proficient in installing, configuring, and maintaining various operating systems.",
      "System Administration: Skilled in user management, file system, backup, and system monitoring.",
    ],
  },
];

export const PROJECTS = [
  {
    name: "ONEFRAME",
    image: oneImg,
    link: "https://oneframe-photo-album.netlify.app/",
    category: "Frontend",
    description:
      "OneFrame is a MERN web app for managing and displaying user albums and photos, featuring popular authentication options for logging in and tools for viewing, editing, and managing content.",
  },
  {
    name: "BMK Foundation",
    image: bmkImg,
    link: "https://bmk-foundation.vercel.app/",
    category: "Frontend",
    description:
      "The React.js-powered BMK Foundation site honors Boniface Mwau wa Kaboi's legacy, promoting community empowerment, education sponsorship, and sports events.",
  },
  {
    name: "Cocktail Hive",
    image: cocktailImg,
    link: "https://thecocktailhive.netlify.app/",
    category: "Frontend",
    description:
      "The Cocktail Hive: Web app for cocktail search and display of similar drinks with ingredients. Utilizes The Cocktail DB API for comprehensive cocktail data.",
  },
  {
    name: "My Shopify",
    image: shopifyImg,
    link: "https://5-hopify.vercel.app/",
    category: "Frontend",
    description:
      "My Shopify: E-commerce app with categorized products for easy browsing. User-friendly interface enables seamless shopping. Developed with ReactJS, integrates API for enhanced functionality.",
  },
  {
    name: "Wander World",
    image: wanderImg,
    category: "Frontend",
    description:
      "Wander World: Platform for sharing travel stories and experiences. Built with ReactJS and Ruby on Rails, enabling users to explore and share journeys.",
  },
  {
    name: "FitHub",
    image: fithubImg,
    link: "https://github.com/MarsMwau/Fithub-Frontend",
    category: "Frontend",
    description:
      "FitHub: Fitness app for tracking workouts, planning routines, and staying motivated. Developed with ReactJS and Ruby on Rails to support users in achieving their fitness goals.",
  },
  {
    name: "FitHub API",
    image: fithubBImg,
    link: "https://github.com/MarsMwau/Fithub-Backend",
    category: "Backend",
    description:
      "FitHub's backend, crafted with Ruby on Rails and SQLite, handles data storage, user authentication, and workout tracking, providing essential support for fitness goals.",
  },
  {
    name: "Heroes API",
    image: heroImg,
    link: "https://github.com/MarsMwau/SUPER-HEROES",
    category: "Backend",
    description:
      "This Rails API facilitates CRUD operations on superheroes, powers, and their associations, empowering developers to manage and retrieve relevant data efficiently.",
  },
];
